import React from 'react';
import { useRouteError } from 'react-router-dom';
import { ErrorBoundary } from './ErrorBoundary';
import { ErrorLoadingPage } from '@/components/screens/ErrorHandling/ErrorLoadingPage';

interface ErrorBoundaryWrapperProps {
  children: React.ReactNode;
}

// This component handles both React Router errors and React errors
const ErrorElement = () => {
  const error = useRouteError() as Error;
  return (
    <ErrorLoadingPage
      errorType="error"
      hideNavBar
      description={`An unexpected error occurred.\n${error?.message || ''}`}
    />
  );
};

export const ErrorBoundaryWrapper = ({
  children,
}: ErrorBoundaryWrapperProps) => {
  return <ErrorBoundary>{children}</ErrorBoundary>;
};
